var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ztree vue-giant-tree",attrs:{"id":_vm.ztreeId}})
}
var staticRenderFns = []

export { render, staticRenderFns }